import { Request } from '../../models/httpClient/Request';
import { IGetItemsResult } from '../../models/httpClient/IResponse';
import { ListResult } from '../../models/httpClient/ListResults';
import WebHttpClient from './WebHttpClient';
import { IPagedItemsParams } from '../../models/httpClient/IListFetcher';

export class WebClientResourceService<TRequestResult extends IGetItemsResult> {
  constructor(private requestType: new (params: IPagedItemsParams) => Request<IPagedItemsParams, TRequestResult>) {}

  public fetchList(params: IPagedItemsParams): Promise<ListResult<TRequestResult>> {
    return WebHttpClient.sendRequest(new this.requestType(params)).then((result: TRequestResult) => {
      const startIndex = params.page ? params.page.startIndex : 0;
      return new ListResult<TRequestResult>(result, startIndex, result.totalCount);
    });
  }
}
